import React, { useEffect, useState, useRef } from 'react';
import { Layout, Row, Select, Divider, Typography, Card, Button } from 'antd';
import { Header } from '../../component/header/header';
import Sidebar from '../../component/siderbar/sidebar';
import './livestream.css';
import { PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { HARDCODED_CONFIGS } from '../configurations/configurations';


const { Content } = Layout;
const { Title } = Typography;
const { Option } = Select;

const STORAGE_KEY = 'rtspConfigs_v1';


export default function Livestream() {
  const [configs, setConfigs] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  


  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    const stored = raw ? JSON.parse(raw) : [];
    const extraStored = (stored || []).filter(s => !HARDCODED_CONFIGS.some(h => h.id === s.id));

    setConfigs([...HARDCODED_CONFIGS, ...extraStored]);
    
    if (HARDCODED_CONFIGS && HARDCODED_CONFIGS.length) {
      setSelectedId(HARDCODED_CONFIGS[0].id);
    }
  }, []);

  // map config id -> demo video in public/
  const VIDEO_MAP = {
    'cfg-1001': 'test2.mp4',
    'cfg-1002': 'test.mp4'
  };

  const getDemoSrc = (cfg) => {
    if (!cfg) return null;
    return VIDEO_MAP[cfg.id] || null;
  };

  const selected = configs.find(c => c.id === selectedId) || null;


  // update video src/play when selection changes
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const cfg = configs.find(c => c.id === selectedId);
    const src = getDemoSrc(cfg);
    // if no mapped video, stop player and mark as not playing
    if (!src) {
      try { v.pause(); } catch {}
      v.src = '';
      setIsPlaying(false);
      return;
    }
    if (v.src && v.src.includes(src)) return; // already loaded
    v.pause();
    v.src = src;
    v.load();
    v.play().catch(()=>{ setIsPlaying(false); });
    setIsPlaying(true);
   }, [selectedId, configs]);

  return (
    <Layout>
      <Header />
      <Layout>
        <Sidebar currentKey={"6"} />
        <Content style={{ padding: '20px 24px' }}>
          <div className="livestream-page">
            <Row>
              <Title className="title" level={2}>Livestream</Title>
            </Row>

            <Divider />

            <div className="livestream-controls" style={{ padding: '12px 0' }}>
              <Select
                placeholder="Select configured stream"
                style={{ width: 480 }}
                value={selectedId}
                onChange={setSelectedId}
                allowClear
              >
                {configs.map(cfg => (
                  <Option key={cfg.id} value={cfg.id}>
                    {cfg.name ? `${cfg.name} - ${cfg.kpi}` : cfg.kpi}
                  </Option>
                ))}
              </Select>
            </div>

            <div className="livestream-screen-wrap">
              <Card className="livestream-screen-card" bordered={false}>
                <video
                ref = {videoRef}
                width="900"
                height="360"
                // src="test.mp4"
                autoPlay
                muted
                loop
                playsInline 
                preload = "none"
                onContextMenu={(e) => e.preventDefault()} // disables right-click menu
                style={{
                  objectFit: "cover",
                  pointerEvents: "none", // disables click-to-pause
                }}
              />
              </Card>
            </div>

            <div className="livestream-selected-title">
              {!selected
                ? 'No stream selected'
                : (getDemoSrc(selected) ? (selected.name || selected.kpi) : 'Stream URL might be incorrect')}
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}